import type { ActionTree, GetterTree, MutationTree } from 'vuex';
import type { PostTopicsFormState } from '~/types/store/post-topics-form';
import type { RootState } from '~/types/store/index';
import type { ITopic } from '~/types/common';

export const state = (): PostTopicsFormState => ({
  topics: [],
});

export const getters: GetterTree<PostTopicsFormState, RootState> = {};

export const mutations: MutationTree<PostTopicsFormState> = {
  setTopics(state, topics: ITopic[]) {
    state.topics = topics;
  },
  addTopic(state, topic: ITopic) {
    state.topics.push(topic);
  },
  updateTopic(state, { id, payload }) {
    const topic = state.topics.find(t => t.id === id);

    if (topic) {
      Object.assign(topic, payload);
    }
  },
};

export const actions: ActionTree<PostTopicsFormState, RootState> = {
  copyTopics({ commit, rootGetters }, { selectedTopicIds }) {
    const topics = (rootGetters['warRoom/topics'] as ITopic[]).map(topic => ({
      ...topic,
      isActive: selectedTopicIds.includes(topic.id),
    }));

    commit('setTopics', topics);
  },
};
